import useI18nData from "./useI18nData";

const docs = [require("./services/mobile-app-development").default];

export default () => useI18nData(docs);
